import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clearProcessStatuses } from '@api/processes';
import { processDetailQueryKey } from './useProcessDetail';

/**
 * `POST /api/v1/processes/:id/clear-statuses` — wipes every node's test-run
 * execution rows and removes the test-run artifacts (S3 + DB) for the
 * process. On success we invalidate the detail query so the editor reads
 * the cleared state in the next render.
 */
export function useClearProcessStatuses() {
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (processId: string) => clearProcessStatuses(processId),
    onSuccess: (_void, processId) => {
      queryClient.invalidateQueries({
        queryKey: processDetailQueryKey(processId),
      });
    },
  });
}
